<div class="card-slide">
    <div class="card-slide-left">
        <div class="card-slide-text">
            <div *ngIf="header" class="card-header">{{header}}</div>
            <div *ngIf="subheader" class="card-subheader">{{subheader}}</div>
        </div>
        <button class="btn outline"  (click)="navigate()">Подробнее</button>
    </div>
    <div class="card-image">
        <img [src]="image"   *ngIf="isImage">
    </div>

</div>